import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Formprops } from './Login.types';
import Spinner from '../../../components/Spinner/Spinner';
import PasswordInput from '../../../components/Form/PasswordInput';

const LoginForm = ({ register, formState: { errors, isSubmitting } }: Formprops) => {
  return (
    <Fragment>
      <label className="form-label" htmlFor="username">
        Usuario
      </label>
      <input
        className={`form-input${errors.username ? ' form-input-invalid' : ''}`}
        type="text"
        id="username"
        autoComplete="username"
        aria-invalid={Boolean(errors.username)}
        aria-describedby={errors.username ? 'username-error' : undefined}
        {...register('username', {
          required: { value: true, message: 'Este campo es requerido' },
          pattern: {
            value: /([\w\d]{1,15}[.][\w\d]{1,15})\w+/,
            message: 'Ingrese un usuario válido',
          },
        })}
      />
      <p className="form-input-error-message" id="username-error">{errors.username?.message}</p>
      <label className="form-label" htmlFor="password">
        Contraseña
      </label>
      <PasswordInput
        className={`form-input${errors.password ? ' form-input-invalid' : ''}`}
        id="password"
        autoComplete="current-password"
        aria-invalid={Boolean(errors.password)}
        aria-describedby={errors.password ? 'password-error' : undefined}
        {...register('password', { required: { value: true, message: 'Este campo es requerido' } })}
      />
      <p className="form-input-error-message" id="password-error">{errors.password?.message}</p>
      <button className="form-button" type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
        {isSubmitting ? <><Spinner label="Iniciando sesión" /><span>Ingresando…</span></> : 'Iniciar sesión'}
      </button>
      <Link to="/forgotpassword" className="form-link">
        ¿Has olvidado la contraseña?
      </Link>
    </Fragment>
  );
};

export default LoginForm;
